import React, { Component, Fragment } from 'react';
import MetaTags from 'react-meta-tags';
import Headertwo from '../layouts/Headertwo';
import Footer from '../layouts/Footer';
// import Breadcrumbs from '../layouts/Breadcrumbs';
// import Workingprocess from '../sections/hometwo/Workingprocess';

import Video from '../sections/service/Video';

// import Client from '../layouts/Client';

class Time extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
        const head = document.querySelector("head");
        const script = document.createElement("script");
        script.setAttribute(
            "src",
            "https://assets.calendly.com/assets/external/widget.js"
        );
        head.appendChild(script);
    }

    render() {
        return (
            <Fragment>
                <MetaTags>
                    <title>J.W. Oliver - Schedule A Call</title>
                    <meta
                        name="description"
                        content="Schedule A Call"
                    />
                </MetaTags>
                <Headertwo />
                {/* <Breadcrumbs breadcrumb={{ pagename: 'Schedule A Call' }} /> */}

                {/* <Workingprocess /> */}
                <Video />

                {/* <div>
                    <div class="calendly-inline-widget" style={{ minWidth: "320px", height: "680px" }} data-url="https://calendly.com/jwo"></div>
                </div> */}

                {/* <section className="client-section">
                    <div className="container">
                        <div className="client-slider section-gap line-top">
                            <Client />
                        </div>
                    </div>
                </section> */}

                <Footer />
            </Fragment>
        );
    }
}

export default Time